import { Link } from '@material-ui/core'
import {
  AppContext,
  assets,
  Checkbox,
  ErrorHandling,
  ImgUploadMutiple,
  Input,
  Title,
  TransactionType,
  RiderAlterationData,
  RiderAlterationService,
  TaskType,
  FileUploadData,
  AddNewLAModal,
  LifeAssuredTable,
  AlterRiderTable,
  removeAbundantSpacesInText,
  SubmissionService,
  getNumberFromString,
  CancelRider,
  RiderAlterationFormData,
  RiderDeleteModal,
  ProductEnum,
  HealthcareDetailPanelModal,
  PolicyBenefitRegistrationBlock
} from '@pulseops/common'
import React from 'react'
import { Controller, FieldArrayWithId, useFieldArray, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from '@mxt/zio'
import { useLoading } from '@mxt/zio-react'
import moment from 'moment'
import { Error, SectionCol, SectionContent, SectionRow } from '@pulseops/submission/common'
import { PolicyServiceProps, UploadedFilesInfo } from '../policy-service-props'
import { RequestAuthenticateData } from '../../request-authen'
import { useIsFocused } from '@react-navigation/native'
import * as O from 'fp-ts/lib/Option'
import * as A from 'fp-ts/lib/Array'

export const RiderAlteration = (props: PolicyServiceProps<RiderAlterationData.SubmissionData>) => {
  const { t, i18n } = useTranslation()
  const [isLoading, bindLoader] = useLoading(false)
  const isFocused = useIsFocused()
  const { showGlobalLoading, showToast } = React.useContext(AppContext.AppContextInstance)
  const [isShowedNewLA, setIsShowedNewLA] = React.useState<boolean>(false)
  const [newLAInfoIndex, setNewLAInfoIndex] = React.useState<number>(-1)
  const [waiverProductList, setWaiverProductList] = React.useState<string[]>([])
  const [classList, setClassList] = React.useState<RiderAlterationService.ClassItem[]>([])
  const [riderDetail, setRiderDetail] = React.useState<CancelRider.DetailCancelRiderInfo>()
  const [policyOwnerInfoData, setPolicyOwnerInfoData] = React.useState<RiderAlterationData.PolicyInfoData>()
  const [riskTypeList, setRiskTypeList] = React.useState<RiderAlterationService.T94RistType[]>([])
  const [hasNewLAForBenefitsRegistration, setHasNewLAForBenefitsRegistration] = React.useState(false)
  const [isDeletedNewLAForBenefitsRegistration, setIsDeletedNewLAForBenefitsRegistration] = React.useState<{ status: boolean; index: number }>({ status: false, index: -1 })
  const [isOpenedHealthcareDetail, setIsOpenedHealthcareDetail] = React.useState<boolean>(false)
  const [healthcareMasterDataList, setHealthcareMasterDataList] = React.useState<RiderAlterationService.HealthcareMasterDataResponse>()
  const [previousHealthcareBenefitList, setPreviousHealthcareBenefitList] = React.useState<RiderAlterationFormData.HealthcareBenefitDetailInfo[]>([])
  const [riderLAIndex, setRiderLAIndex] = React.useState<number>(0)
  const [riderSubindex, setRiderSubindex] = React.useState<number>(0)
  const [LABirthDate, setLABirthDate] = React.useState('')
  const policyNum = props.policyNumber || ''
  const officeCode = props.officeCode || ''
  const riderAlterationForm = useForm<RiderAlterationFormData.RiderAlteration>({
    defaultValues: {
      LARiderAlterationList: [],
      newRiderLAList: [],
      healthDocuments: [],
      isAddRider: false,
      isRiderAlteration: false,
      requiredPayinAmount: '',
      isShowBenefitsRegistrationBlock: false,
      isCheckedBenefitsRegistrationBlock: false
    }
  })

  const LAFieldList = useFieldArray({
    control: riderAlterationForm.control,
    name: 'LARiderAlterationList'
  })

  const NewRiderLAList = useFieldArray({
    control: riderAlterationForm.control,
    name: 'newRiderLAList'
  })

  React.useEffect(() => {
    showGlobalLoading(isLoading)
  }, [isLoading])

  React.useEffect(() => {
    if (isFocused && !!policyNum) {
      pipe(
        SubmissionService.getPolicy(policyNum),
        ZIO.flatMap((policyResponse) => {
          return ZIO.zipPar(
            RiderAlterationService.getDetail(policyNum, policyResponse.body),
            getPolicyOwerInfo(policyResponse.body),
            RiderAlterationService.getWaiverProducts('TR517', ''),
            RiderAlterationService.getClassList('TV948'),
            RiderAlterationService.getT94RistTypeList(),
            RiderAlterationService.getHealthcareBenefitMasterData('HCR9')
          )
        }),
        ZIO.flatMap(([responseData, policyOwerInfo, waiverList, classArray, riskTypeArr, healthcareBenefitMasterData]) => {
          setRiderDetail(responseData)
          setWaiverProductList(waiverList)
          setPolicyOwnerInfoData(policyOwerInfo)
          setClassList(classArray)
          setRiskTypeList(riskTypeArr)
          setHealthcareMasterDataList(healthcareBenefitMasterData)
          const isShowBenefitsRegistrationBlock = responseData.coverageCode === 'EUS5' && moment(responseData.premCessDateOfPolicy).isAfter(moment(new Date()))
          riderAlterationForm.setValue('isShowBenefitsRegistrationBlock', isShowBenefitsRegistrationBlock)
          return ZIO.fromPromise(() => initData(responseData, waiverList, classArray, riskTypeArr))
        }),
        bindLoader,
        ErrorHandling.run()
      )
    }
    return () => {
      setRiderDetail(undefined)
      setWaiverProductList([])
      setPolicyOwnerInfoData(undefined)
      setClassList([])
      setRiskTypeList([])
      setRiderLAIndex(0)
      setRiderSubindex(0)
      setHasNewLAForBenefitsRegistration(false)
      setIsDeletedNewLAForBenefitsRegistration({ status: false, index: -1 })
      setIsOpenedHealthcareDetail(false)
      setHealthcareMasterDataList(undefined)
      setPreviousHealthcareBenefitList([])
      riderAlterationForm.reset({
        LARiderAlterationList: [],
        newRiderLAList: [],
        healthDocuments: [],
        isAddRider: false,
        isRiderAlteration: false,
        requiredPayinAmount: '',
        totalPremium: 0,
        isShowBenefitsRegistrationBlock: false,
        isCheckedBenefitsRegistrationBlock: false
      })
    }
  }, [isFocused])

  const getPolicyOwerInfo = (policyData: SubmissionService.PolicyType) => {
    return pipe(
      ZIO.zipPar(
        SubmissionService.getCustomer(policyData.clientDespatchAddress || ''),
        SubmissionService.getCustomer(policyData.owners.id || '')
      ),
      ZIO.map(([customerInfo, owner]) => {
        return {
          customerId: policyData?.owners.id || '',
          poName: owner.body.name,
          secuityNo: customerInfo.body.externalIds.SOE_VALUE || '',
          dob: customerInfo.body.dob || '',
          gender: customerInfo.body.sex || ''
        }
      })
    )
  }

  const initData = (
    responseData: CancelRider.DetailCancelRiderInfo,
    waiverList: string[],
    classArray: RiderAlterationService.ClassItem[],
    riskTypeArr: RiderAlterationService.T94RistType[]
  ) => {
    let riderFormArray: Array<RiderAlterationFormData.CurrentRiderForm> = []
    const LARiderItemList = responseData.laRiderInfo
    return pipe(
      LARiderItemList,
      A.map((lifeAssuredItem) => RiderAlterationService.getRiderList(policyNum, lifeAssuredItem.lifeNo ?? '')),
      ZIO.sequence,
      ZIO.map((riderNameArr) => {
        const lifeAssuredArr = LARiderItemList.map((item) => {
          const alteredRiderList = riderNameArr.find((x) => x.lifeNo === item.lifeNo)?.riderArr ?? []
          return {
            ...item,
            alteredRiderList: alteredRiderList
          }
        })
        return lifeAssuredArr
      }),
      ZIO.map((lifeAssuredList) => {
        lifeAssuredList.map((LAItem) => {
          LAItem.riders.map((rider) => {
            const riderInfoItem = responseData.riderNameList.find((x) => x.code === rider.productCode)
            rider.productName = getRiderName(riderInfoItem, i18n.language)
            const isWaiverProduct = waiverList.some((waiveritem) => waiveritem === rider.productCode)
            const classNumberList = getArrayFromUndefinedItem(classArray, rider.productCode)
            const isClassNumber = isWaiverProduct || classNumberList.length <= 0 ? false : true
            riderFormArray.push({
              riderCode: rider.productCode,
              riderName: rider.productName,
              isWaiverProduct: isWaiverProduct,
              isClassNumber: isClassNumber,
              classNumberList: isClassNumber ? classNumberList : [],
              // SelectRowForRider: false,
              riskCommDate: rider.riskCommDate,
              riskCessDate: rider.riskCessDate,
              sumAssured: rider.sumAssured,
              alteredSumAssured: '',
              installmentPrem: rider.installmentPrem,
              newInstallmentPremium: 0,
              lifeNo: rider.lifeNo,
              coverageNo: rider.coverageNo,
              riderNo: rider.riderNo,
              riderStatus: rider.riderStatus
            })
          })

          LAFieldList.append({
            // selectAllForLA: false,
            LAName: LAItem.clientName,
            lifeAssured: LAItem.lifeAssured,
            currentRiders: riderFormArray
          })
          //set default value for LANewRiderList
          const alteredRiderList = LAItem.alteredRiderList
            .filter((x) => x.enable)
            .filter((x) => checkServicingAgentRule(responseData, x.code))
            .filter((x) => !LAItem.riders.some((item) => item.productCode === x.code))
            .filter((riderinfo) => !LAItem.mainProducts.some((rider) => rider.productCode === riderinfo.code))
            .filter((item) =>
              !["VLR9", "ULR9", "TLA9", "VLM1", "EUS5"].includes(responseData.coverageCode || '')
              || (!checkNewRiderWithSameRiskType(item, LAItem.riders, riskTypeArr) && checkValidRiderForEUS5(responseData, item))
            )
          NewRiderLAList.append({
            LAName: LAItem.clientName,
            lifeAssured: LAItem.lifeAssured,
            isNewLA: false,
            newRiderList: [],
            lifeNo: LAItem.lifeNo ?? '',
            alteredRiderList: alteredRiderList,
            isCheckedBenefitsRegistration: false,
            isNewLAForBenefitsRegistration: false,
            lifeAssuredType: '',
            benefitsRegistrationRiderInfo: {
              riderName: { label: '', value: '' },
              sumAssured: '',
              policyPeriod: '',
              riderType: ''
            },
            LADateOfBirth: LAItem.LADateOfBirth || ''
          })
          riderFormArray = []
        })
        riderAlterationForm.setValue('totalPremium', responseData.totalPremium)
        return lifeAssuredList
      }),
      bindLoader,
      ErrorHandling.run()
    )
  }

  const checkNewRiderWithSameRiskType = (newAdditionalRider: RiderAlterationService.RiderNameInfo, existedRiderList: CancelRider.CancelRiderInfo[],
    riskTypeArr: RiderAlterationService.T94RistType[]
  ) => {
    let isSameRiskType = false
    for (let i = 0; i < existedRiderList.length; i++) {
      const existedRiskType = pipe(
        riskTypeArr.find((x) => x.productCode === existedRiderList[i].productCode),
        O.fromNullable,
        O.fold(
          () => '',
          (item) => item.riskType
        )
      )
      const newRiskType = pipe(
        riskTypeArr.find((x) => x.productCode === newAdditionalRider.code),
        O.fromNullable,
        O.fold(
          () => '',
          (item) => item.riskType
        )
      )
      if (!!newRiskType && !!existedRiskType && existedRiskType === newRiskType) {
        isSameRiskType = true
        break
      }
    }
    return isSameRiskType
  }

  const checkValidRiderForEUS5 = (detailData: CancelRider.DetailCancelRiderInfo | undefined, newAdditionalRider: RiderAlterationService.RiderNameInfo) => {
    const constantRiderList = ["OPW7", "WOP3", "DSR2"]
    const lifeAssuredListWithRiders = detailData?.laRiderInfo || []
    if (detailData && detailData?.coverageCode === "EUS5") {
      const condition1 = lifeAssuredListWithRiders.some((item) => item.originalRiderList?.some((rider) =>
        constantRiderList.includes(rider.productCode)
        && [ProductEnum.Status.IF, ProductEnum.Status.LA].includes(rider.riderStatus as ProductEnum.Status)
      ))
      const condition2 = lifeAssuredListWithRiders.some((item) => item.originalRiderList?.some((rider) =>
        constantRiderList.includes(rider.productCode)
        && ![ProductEnum.Status.IF, ProductEnum.Status.LA].includes(rider.riderStatus as ProductEnum.Status)
      ))
      if (condition1) {
        return !["TLR9", "ADD9", "CIR9", "CIW9", "HSR9", "HCR9"].includes(newAdditionalRider.code)
          ? true : false
      } else if (condition2) {
        return ["TLR9", "ADD9", "CIR9", "CIW9", "HSR9", "HCR9"].includes(newAdditionalRider.code)
          ? true : false
      } else {
        return true
      }
    } else {
      return true
    }
  }
  const checkServicingAgentRule = (initialRiderAlterData: CancelRider.DetailCancelRiderInfo | undefined, riderCode: string) => {
    const isPDAgentCode = initialRiderAlterData?.servicingAgentCode?.startsWith('69')
    const isADAgentCode = initialRiderAlterData?.servicingAgentCode?.startsWith('60')
    if (isADAgentCode && (!['HCR1', 'HCR3'].includes(riderCode) || moment(new Date()).isBefore(moment('2026-10-01')))) {
      return true
    } else if (isPDAgentCode) {
      if (['HCR1', 'HCR3'].includes(riderCode)) {
        const isEnabledHCR1_3 = pipe(
          O.fromNullable(initialRiderAlterData?.withdrawalHCRList?.find((x) => x.bankName === initialRiderAlterData?.agentBankCode)),
          O.fold(
            () => true,
            (withdrawalItem) => {
              return withdrawalItem.riderCodeList.includes(riderCode) && moment(withdrawalItem.effectiveTo).isValid()
                ? moment(new Date()).isSameOrBefore(moment(withdrawalItem.effectiveTo, 'YYYY-MM-DD'), 'day')
                : true
            }
          )
        )
        return isEnabledHCR1_3
      } else {
        return true
      }
    } else {
      return false
    }
  }

  const getArrayFromUndefinedItem = (array: RiderAlterationService.ClassItem[], riderCode: string) => {
    return pipe(
      array.find((x) => x.riderCode === riderCode)?.classList,
      O.fromNullable,
      O.map((item) => item),
      O.getOrElse(() => [] as string[])
    )
  }

  const benefitRegistrationRiderName = React.useMemo(() => {
    return !!riderDetail ? pipe(
      O.fromNullable(riderDetail.riderNameList.find((x) => x.code === 'BEN001')),
      O.map((item) => ({ label: i18n.language === 'en' ? item.name : item.nameVi, value: item.code })),
      O.getOrElse(() => ({ label: '', value: '' }))
    ) : { label: '', value: '' }
  }, [riderDetail])


  const getRiderName = (item: any, isEN = 'en') => {
    return !!item ? (isEN === 'en' ? item.name : item.nameVi) : ''
  }

  const openInsertLAModal = (isNewLAForBenefitsRegistration: boolean) => {
    setNewLAInfoIndex(-1)
    setIsShowedNewLA(true)
    setHasNewLAForBenefitsRegistration(isNewLAForBenefitsRegistration)
  }
  const closeAddLAModal = () => {
    setIsShowedNewLA(false)
  }

  const convertDateStringForSubmit = (strDate: string) => {
    return moment(strDate).format('YYYY-MM-DD')
  }

  const addNewRiderForExistedLA = (
    index: number,
    fieldItem: FieldArrayWithId<RiderAlterationFormData.RiderAlteration, 'newRiderLAList', 'id'>
  ) => {
    const newRiderList = [
      ...fieldItem.newRiderList,
      {
        riderName: { label: '', value: '' },
        sumAssured: '',
        policyPeriod: '',
        isWaiverProduct: false,
        isClassNumber: false,
        classNumberList: []
      }
    ]
    NewRiderLAList.update(index, {
      LAName: fieldItem.LAName,
      lifeAssured: fieldItem.lifeAssured,
      isNewLA: fieldItem.isNewLA,
      newRiderList: newRiderList,
      newLAInfo: fieldItem.newLAInfo,
      lifeNo: fieldItem.lifeNo,
      alteredRiderList: fieldItem.alteredRiderList,
      LADateOfBirth: fieldItem.LADateOfBirth
    })
  }

  const removeRiderForExistedLA = (
    index: number,
    subIndex: number,
    fieldItem: FieldArrayWithId<RiderAlterationFormData.RiderAlteration, 'newRiderLAList', 'id'>
  ) => {
    // remove item in array with index
    let customedRiderList = riderAlterationForm.watch(`newRiderLAList.${index}.newRiderList`)
    customedRiderList.splice(subIndex, 1)
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList`, [])
    NewRiderLAList.update(index, {
      LAName: fieldItem.LAName,
      lifeAssured: fieldItem.lifeAssured,
      isNewLA: fieldItem.isNewLA,
      newLAInfo: fieldItem.newLAInfo,
      lifeNo: fieldItem.lifeNo,
      alteredRiderList: fieldItem.alteredRiderList,
      newRiderList: [],
      LADateOfBirth: fieldItem.LADateOfBirth
    })
    riderAlterationForm.setValue(`newRiderLAList.${index}.alteredRiderList`, fieldItem.alteredRiderList)
    riderAlterationForm.setValue(`newRiderLAList.${index}.LAName`, fieldItem.LAName)
    riderAlterationForm.setValue(`newRiderLAList.${index}.lifeAssured`, fieldItem.lifeAssured)
    riderAlterationForm.setValue(`newRiderLAList.${index}.isNewLA`, fieldItem.isNewLA)
    riderAlterationForm.setValue(`newRiderLAList.${index}.newLAInfo`, fieldItem.newLAInfo)
    riderAlterationForm.setValue(`newRiderLAList.${index}.lifeNo`, fieldItem.lifeNo)
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList`, customedRiderList)
    riderAlterationForm.setValue(`newRiderLAList.${index}.LADateOfBirth`, fieldItem.LADateOfBirth)
    riderAlterationForm.watch(`newRiderLAList.${index}.newRiderList`).forEach((riderItem, riderIndex) => {
      if (riderIndex < customedRiderList.length) {
        riderAlterationForm.setValue(
          `newRiderLAList.${index}.newRiderList.${riderIndex}.riderName`,
          riderItem.riderName
        )
        riderAlterationForm.setValue(
          `newRiderLAList.${index}.newRiderList.${riderIndex}.isWaiverProduct`,
          riderItem.isWaiverProduct
        )
        riderAlterationForm.setValue(
          `newRiderLAList.${index}.newRiderList.${riderIndex}.policyPeriod`,
          riderItem.policyPeriod
        )
        riderAlterationForm.setValue(
          `newRiderLAList.${index}.newRiderList.${riderIndex}.sumAssured`,
          riderItem.sumAssured
        )
        riderAlterationForm.setValue(
          `newRiderLAList.${index}.newRiderList.${riderIndex}.isClassNumber`,
          riderItem.isClassNumber
        )
        riderAlterationForm.setValue(
          `newRiderLAList.${index}.newRiderList.${riderIndex}.classNumberList`,
          riderItem.classNumberList
        )
      }
    })
  }

  const addNewRiderLA = (newItem: RiderAlterationFormData.NewLAInfo, hasNewLAForBenefitsRegistration?: boolean) => {
    pipe(
      ZIO.effect(() => {
        const lifeNumber = riderAlterationForm.watch('newRiderLAList').reduce((oldLifeNo, item) => {
          const lifeNo = Number(item.lifeNo ?? '0')
          if (oldLifeNo <= lifeNo) {
            return lifeNo
          } else {
            return oldLifeNo
          }
        }, 0)
        const lifeNo = '0' + (lifeNumber + 1).toString()
        return lifeNo
      }),
      ZIO.flatMap((lifeNum) => RiderAlterationService.getRiderList(policyNum, lifeNum)),
      ZIO.map((riderResponse) => {
        const LAName = newItem.surname + ' ' + newItem.firstName
        const alteredRiderList = riderResponse.riderArr
          .filter((x) => x.enable)
          .filter((x) => checkServicingAgentRule(riderDetail, x.code))
          .filter((riderItem) => checkValidRiderForEUS5(riderDetail, riderItem))
        const customedLADateOfBirth = newItem.dateOfBirth ? moment(newItem.dateOfBirth).format('YYYYMMDD') : ''
        const newLAItem: RiderAlterationFormData.NewRiderLAData = {
          LAName: LAName,
          lifeAssured: '',
          isNewLA: true,
          newRiderList: [],
          newLAInfo: newItem,
          lifeNo: riderResponse.lifeNo,
          alteredRiderList: alteredRiderList,
          isNewLAForBenefitsRegistration: hasNewLAForBenefitsRegistration,
          isCheckedBenefitsRegistration: false,
          LADateOfBirth: customedLADateOfBirth
        }
        NewRiderLAList.append(newLAItem)
      }),
      bindLoader,
      ErrorHandling.run()
    )
  }

  const updateNewLifeAssuresAfterDelete = (
    newItem: RiderAlterationFormData.NewRiderLAData,
    index: number,
    lifeNo: string
  ) => {
    return pipe(
      ZIO.succeed(lifeNo),
      ZIO.flatMap((lifeNum) => RiderAlterationService.getRiderList(policyNum, lifeNum)),
      ZIO.map((riderResponse) => {
        const alteredRiderList = riderResponse.riderArr
          .filter((p) => p.enable)
          .filter((x) => checkServicingAgentRule(riderDetail, x.code))
          .filter((riderItem) => checkValidRiderForEUS5(riderDetail, riderItem))
        const newRiderList = newItem.newRiderList
        // console.log('newRiderList:' + newItem.newRiderList)
        riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList`, [])
        NewRiderLAList.update(index, {
          LAName: newItem.LAName,
          lifeAssured: newItem.lifeAssured,
          isNewLA: newItem.isNewLA,
          newLAInfo: newItem.newLAInfo,
          lifeNo: lifeNo,
          alteredRiderList: alteredRiderList,
          newRiderList: newRiderList,
          isNewLAForBenefitsRegistration: newItem.isNewLAForBenefitsRegistration,
          isCheckedBenefitsRegistration: newItem.isCheckedBenefitsRegistration,
          benefitsRegistrationRiderInfo: newItem.benefitsRegistrationRiderInfo,
          LADateOfBirth: newItem.LADateOfBirth
        })
        riderAlterationForm.setValue(`newRiderLAList.${index}.alteredRiderList`, alteredRiderList)
        riderAlterationForm.setValue(`newRiderLAList.${index}.LAName`, newItem.LAName)
        riderAlterationForm.setValue(`newRiderLAList.${index}.lifeAssured`, newItem.lifeAssured)
        riderAlterationForm.setValue(`newRiderLAList.${index}.isNewLA`, newItem.isNewLA)
        riderAlterationForm.setValue(`newRiderLAList.${index}.newLAInfo`, newItem.newLAInfo)
        riderAlterationForm.setValue(`newRiderLAList.${index}.lifeNo`, lifeNo)
        riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList`, newRiderList)
        riderAlterationForm.setValue(`newRiderLAList.${index}.isNewLAForBenefitsRegistration`, newItem.isNewLAForBenefitsRegistration)
        riderAlterationForm.setValue(`newRiderLAList.${index}.isCheckedBenefitsRegistration`, newItem.isCheckedBenefitsRegistration)
        riderAlterationForm.setValue(`newRiderLAList.${index}.benefitsRegistrationRiderInfo`, newItem.benefitsRegistrationRiderInfo)
        riderAlterationForm.setValue(`newRiderLAList.${index}.LADateOfBirth`, newItem.LADateOfBirth)
        riderAlterationForm.watch(`newRiderLAList.${index}.newRiderList`).forEach((riderItem, riderIndex) => {
          if (riderIndex < newRiderList.length) {
            riderAlterationForm.setValue(
              `newRiderLAList.${index}.newRiderList.${riderIndex}.riderName`,
              riderItem.riderName
            )
            riderAlterationForm.setValue(
              `newRiderLAList.${index}.newRiderList.${riderIndex}.isWaiverProduct`,
              riderItem.isWaiverProduct
            )
            riderAlterationForm.setValue(
              `newRiderLAList.${index}.newRiderList.${riderIndex}.policyPeriod`,
              riderItem.policyPeriod
            )
            riderAlterationForm.setValue(
              `newRiderLAList.${index}.newRiderList.${riderIndex}.sumAssured`,
              riderItem.sumAssured
            )
            riderAlterationForm.setValue(
              `newRiderLAList.${index}.newRiderList.${riderIndex}.isClassNumber`,
              riderItem.isClassNumber
            )
            riderAlterationForm.setValue(
              `newRiderLAList.${index}.newRiderList.${riderIndex}.classNumberList`,
              riderItem.classNumberList
            )

            riderAlterationForm.setValue(
              `newRiderLAList.${index}.newRiderList.${riderIndex}.riderType`,
              riderItem.riderType
            )
          }
        })
      })
    )
  }

  const onChangeNewRider = (index: number, subIndex: number, riderCode: string) => {
    const isWaiverProduct = waiverProductList.some((item) => item === riderCode)
    const classNumberList = getArrayFromUndefinedItem(classList, riderCode)
    const isClassNumber = isWaiverProduct || classNumberList.length <= 0 ? false : true
    const LADateOfBirth = riderAlterationForm.watch(`newRiderLAList.${index}.LADateOfBirth`) || ''
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.sumAssured`, '')
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.policyPeriod`, '')
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.isWaiverProduct`, isWaiverProduct)
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.isClassNumber`, isClassNumber)
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.classNumberList`, classNumberList)
    setRiderLAIndex(index)
    setRiderSubindex(subIndex)
    if (riderCode === 'HCR9') {
      if (getLifeAssuredAgeByDay(LADateOfBirth) < 30 || getLifeAssuredAgeByYear(LADateOfBirth) > 70) {
        showToast(t('message:MS020133'), 'error')
        setIsOpenedHealthcareDetail(false)
        setPreviousHealthcareBenefitList([])
        riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.riderName`, { label: '', value: '' })
      } else {
        initialHealthcareForm(index, subIndex, LADateOfBirth)
        // parse data to json for avoiding sharing object refs
        setPreviousHealthcareBenefitList(JSON.parse(JSON.stringify(riderAlterationForm.getValues(`newRiderLAList.${index}.newRiderList.${subIndex}.healthcareBenefitDetailList`) || [])))
        setIsOpenedHealthcareDetail(true)
      }
    } else {
      setIsOpenedHealthcareDetail(false)
      setPreviousHealthcareBenefitList([])
      riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.healthcareBenefitDetailList`, [])
    }
  }

  const initialHealthcareForm = (index: number, subIndex: number, LADateOfBirth: string) => {
    const benefitList = pipe(
      O.fromNullable(healthcareMasterDataList?.body.healthCareBenefitList),
      O.fold(
        () => [],
        (healthCareBenefitList) => healthCareBenefitList
      )
    )
    const healthcareBenefitList: RiderAlterationFormData.HealthcareBenefitDetailInfo[] = []
    for (let i = 0; i < benefitList.length; i++) {
      const isIPBenefitItem = benefitList[i].name === "IP"
      const isMABenefitItem = benefitList[i].name === "MA"
      const optionSA = isIPBenefitItem
        ? { label: "100M", value: "100000000" }
        : isMABenefitItem
          ? { label: "8%", value: "0.08" }
          : null
      const sumAssured = isIPBenefitItem ? 100000000 : 0
      const customedCopay = { label: "Y", value: "Y" }
      const isDisabledCopay = isIPBenefitItem ? false : true
      const policyRemainingTerm = moment(riderDetail?.riskCessDateOfPolicy).diff(moment(new Date()), 'years')
      const customedIPTerm = Math.min(100 - getLifeAssuredAgeByYear(LADateOfBirth), policyRemainingTerm)
      const customedMATerm = Math.min(50 - getLifeAssuredAgeByYear(LADateOfBirth), customedIPTerm).toString()
      const customedTerm = isMABenefitItem ? customedMATerm : customedIPTerm.toString()
      const benefitName = i18n.language === 'en' ? benefitList[i].valueEn : benefitList[i].valueVi
      healthcareBenefitList.push({
        isCheckedBenefit: isIPBenefitItem,
        benefit: benefitList[i].name,
        benefitName: benefitName,
        copay: customedCopay,
        term: customedTerm,
        optionSA: optionSA,
        sumAssured: sumAssured.toString(),
        isDisabledCopay: isDisabledCopay
      })
    }
    riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.healthcareBenefitDetailList`, healthcareBenefitList)
  }

  const getLifeAssuredAgeByYear = (LADateOfBirth: string) => {
    const LAAge = moment(new Date()).diff(moment(LADateOfBirth, 'YYYYMMDD'), 'years')
    return LADateOfBirth ? LAAge : 0
  }

  const getLifeAssuredAgeByDay = (LADateOfBirth: string) => {
    return LADateOfBirth ? moment(new Date()).diff(moment(LADateOfBirth, 'YYYYMMDD'), 'days') : 0
  }

  const removeNewLA = (index: number) => {
    NewRiderLAList.remove(index)
    const newRiderLAList = riderAlterationForm.watch(`newRiderLAList`)
    pipe(
      newRiderLAList,
      A.map((LAItem) => {
        if (LAItem.isNewLA) {
          const index = newRiderLAList.indexOf(LAItem)
          const highestOldNum = riderAlterationForm.watch('newRiderLAList').reduce((oldLifeNo, item) => {
            const lifeNo = Number(item.lifeNo ?? '0')
            return oldLifeNo <= lifeNo && !item.isNewLA ? lifeNo : oldLifeNo
          }, 0)
          const lifeNo = '0' + (highestOldNum + 1).toString()
          return updateNewLifeAssuresAfterDelete(LAItem, index, lifeNo)
        } else {
          return ZIO.unit
        }
      }),
      ZIO.sequence,
      bindLoader,
      ErrorHandling.run()
    )
  }

  const viewLADetail = (index: number) => {
    setNewLAInfoIndex(index)
    // setIsViewLADetail(true)
    setIsShowedNewLA(true)
  }

  const onCheckBenefitsRegistrationEvent = (checkedValue: boolean, checkedIndex: number) => {
    let i = 0
    const sumAssuredOfBenefit = Math.min(0.5 * (riderDetail?.sumAssuredOfBasic || 0), 2000000000).toString()
    const LAListWithNewRider = riderAlterationForm.watch(`newRiderLAList`)
    // loop through the list and set all other items to false and lifeAssuredType field is empty except the one at the index
    if (LAListWithNewRider.some((item, index) => index !== checkedIndex)) {
      while (i < LAListWithNewRider.length) {
        if (i !== checkedIndex) {
          NewRiderLAList.update(i, {
            ...LAListWithNewRider[i],
            isCheckedBenefitsRegistration: false,
            isNewLAForBenefitsRegistration: LAListWithNewRider[i].isNewLAForBenefitsRegistration,
            lifeAssuredType: '',
            benefitsRegistrationRiderInfo: {
              riderName: { label: '', value: '' },
              sumAssured: '',
              policyPeriod: '',
              riderType: ''
            }
          })
        }
        i++
      }
    }

    NewRiderLAList.update(checkedIndex, {
      ...LAListWithNewRider[checkedIndex],
      isCheckedBenefitsRegistration: checkedValue,
      isNewLAForBenefitsRegistration: LAListWithNewRider[checkedIndex].isNewLAForBenefitsRegistration,
      lifeAssuredType: 'POL_BENEFIT_REGISTER',
      benefitsRegistrationRiderInfo: {
        riderName: benefitRegistrationRiderName,
        sumAssured: sumAssuredOfBenefit,
        policyPeriod: '4',
        riderType: 'BENEFIT'
      }
    })
    riderAlterationForm.setValue(`newRiderLAList.${checkedIndex}.isCheckedBenefitsRegistration`, checkedValue)
    riderAlterationForm.setValue(`newRiderLAList.${checkedIndex}.isNewLAForBenefitsRegistration`, LAListWithNewRider[checkedIndex].isNewLAForBenefitsRegistration)
    riderAlterationForm.setValue(`newRiderLAList.${checkedIndex}.lifeAssuredType`, 'POL_BENEFIT_REGISTER')
    riderAlterationForm.setValue(`newRiderLAList.${checkedIndex}.benefitsRegistrationRiderInfo`, {
      riderName: benefitRegistrationRiderName,
      sumAssured: sumAssuredOfBenefit,
      policyPeriod: '4',
      riderType: 'BENEFIT'
    })
  }

  const openInsertedNewLAPopUp = () => {
    const submissionDetailData = riderAlterationForm.watch(`newRiderLAList.${newLAInfoIndex}.newLAInfo`)
    const isDetailView = newLAInfoIndex >= 0 ? true : false
    return isShowedNewLA ? (
      <AddNewLAModal
        title={t('RiderAlteration:NewLAInformation')}
        isVisible={isShowedNewLA}
        isConfirmed={props.isConfirmed || isDetailView}
        onClose={closeAddLAModal}
        isDetailView={isDetailView}
        detailIndex={newLAInfoIndex}
        policyInfoData={policyOwnerInfoData}
        riderAlterationForm={riderAlterationForm}
        hasNewLAForBenefitsRegistration={hasNewLAForBenefitsRegistration}
        onSuccess={addNewRiderLA}
        submissionDetailData={submissionDetailData}
      />
    ) : (
      <></>
    )
  }

  const onEditRiderEvent = (index: number, subIndex: number, riderCode: string) => {
    setRiderLAIndex(index)
    setRiderSubindex(subIndex)
    if (riderCode === 'HCR9') {
      // parse data to json for avoiding sharing object refs
      setPreviousHealthcareBenefitList(JSON.parse(JSON.stringify(riderAlterationForm.getValues(`newRiderLAList.${index}.newRiderList.${subIndex}.healthcareBenefitDetailList`) || [])))
      setIsOpenedHealthcareDetail(true)
    } else {
      setIsOpenedHealthcareDetail(false)
      setPreviousHealthcareBenefitList([])
      riderAlterationForm.setValue(`newRiderLAList.${index}.newRiderList.${subIndex}.healthcareBenefitDetailList`, [])
    }
  }

  const getRiderSubmissionData = (riderForm: RiderAlterationFormData.RiderAlteration) => {
    const requiredPayInAmount = Number(riderForm.requiredPayinAmount ?? '0')
    const lifeAssuredList: Array<RiderAlterationData.LifeAssuredList> = !riderForm.isRiderAlteration
      ? []
      : riderForm.LARiderAlterationList.map((LAItem) => {
        const riderList = LAItem.currentRiders.map((riderItem) => {
          const riskCommDate = convertDateStringForSubmit(riderItem.riskCommDate)
          const riskCessDate = convertDateStringForSubmit(riderItem.riskCessDate)
          const newInstallmentPremium = riderForm.totalPremium - riderItem.installmentPrem
          const alteredSumAssured = Number(getNumberFromString(riderItem.alteredSumAssured))
          return {
            coverageCode: riderItem.riderCode,
            riskCommDate: riskCommDate,
            riskCessDate: riskCessDate,
            sumAssured: riderItem.sumAssured,
            installmentPremium: riderItem.installmentPrem,
            newInstallmentPremium: newInstallmentPremium,
            alteredSumAssured: alteredSumAssured,
            lifeNo: riderItem.lifeNo,
            coverageNo: riderItem.coverageNo,
            riderNo: riderItem.riderNo,
            riderStatus: riderItem.riderStatus
          }
        })
        return {
          clientNo: LAItem.lifeAssured,
          riderList: riderList
        }
      })
    const lifeAssuredAdditions = !riderForm.isAddRider && !riderForm.isCheckedBenefitsRegistrationBlock
      ? []
      : riderForm.newRiderLAList.map((newItem) => {
        const isUSTax = newItem.newLAInfo?.USTaxDeclaration === 'Y' ? true : false
        const dateOfBirth = newItem.isNewLA ? moment(newItem.newLAInfo?.dateOfBirth).format('YYYYMMDD') : ''
        const issueDate = newItem.isNewLA ? moment(newItem.newLAInfo?.issuedDate).format('YYYYMMDD') : ''
        const issuePlace = !!newItem.newLAInfo?.issuePlace ? newItem.newLAInfo?.issuePlace.value : ''
        const averageIncome = !!newItem.newLAInfo?.averageIncome ? newItem.newLAInfo?.averageIncome.value : ''
        const locationCode = `${newItem.newLAInfo?.city?.value || ''}${newItem.newLAInfo?.ward?.value || ''}`
        const fullName = newItem.isNewLA
          ? removeAbundantSpacesInText(newItem.newLAInfo?.surname ?? '') +
          ' ' +
          removeAbundantSpacesInText(newItem.newLAInfo?.firstName ?? '')
          : newItem.LAName
        const isNewLAForBenefitsRegistration = newItem.isNewLAForBenefitsRegistration
        const isCheckedBenefitsRegistration = newItem.isCheckedBenefitsRegistration
        const benefitsRegistrationRiderInfo = newItem.isCheckedBenefitsRegistration ? {
          riderName: newItem.benefitsRegistrationRiderInfo?.riderName.value || '',
          sumAssured: newItem.benefitsRegistrationRiderInfo?.sumAssured || '',
          policyPeriod: newItem.benefitsRegistrationRiderInfo?.policyPeriod || '',
          riderType: newItem.benefitsRegistrationRiderInfo?.riderType || '',
        } : undefined
        let newLifeAssured: RiderAlterationData.NewLifeAssured = {
          lastName: newItem.newLAInfo?.surname ?? '',
          firstName: newItem.newLAInfo?.firstName ?? '',
          fullName: fullName,
          isNewLA: newItem.isNewLA,
          documentType: newItem.newLAInfo?.documentType.value ?? '',
          idNumber: newItem.newLAInfo?.IDNumber ?? '',
          issuePlace: issuePlace,
          issueDate: issueDate,
          isUSTax: isUSTax,
          dateOfBirth: dateOfBirth,
          gender: newItem.newLAInfo?.gender.value ?? '',
          nationality: newItem.newLAInfo?.nationality.value ?? '',
          mobileCode: newItem.newLAInfo?.mobilePhoneCode.value ?? '',
          mobilePhone: newItem.newLAInfo?.mobilePhone ?? '',
          email: newItem.newLAInfo?.email ?? '',
          occupation: newItem.newLAInfo?.occupation.value ?? '',
          jobDescription: newItem.newLAInfo?.jobDescription ?? '',
          jobTitle: newItem.newLAInfo?.jobTitle ?? '',
          companyName: newItem.newLAInfo?.companyName ?? '',
          companyAddress: newItem.newLAInfo?.companyAddress ?? '',
          averageIncome: averageIncome,
          lifeNo: newItem.lifeNo ?? '',
          clientNumber: newItem.lifeAssured,
          lifeAssuredType: newItem.lifeAssuredType || '',
          isNewLAForBenefitsRegistration: isNewLAForBenefitsRegistration,
          isCheckedBenefitsRegistration: isCheckedBenefitsRegistration,
          benefitsRegistrationRiderInfo: benefitsRegistrationRiderInfo,
          riderListAdditional: newItem.newRiderList.map((subRider) => {
            const healthcareBenefitDetailArray = pipe(
              O.fromNullable(subRider.healthcareBenefitDetailList),
              O.fold(
                () => [],
                (benefitList) => {
                  return benefitList.filter((p) => p.isCheckedBenefit).map((benefitItem) => {
                    return {
                      isCheckedBenefit: benefitItem.isCheckedBenefit,
                      benefit: benefitItem.benefit,
                      sumAssured: benefitItem.sumAssured,
                      optionSA: benefitItem.optionSA?.value || '',
                      copay: benefitItem.copay.value || '',
                      term: benefitItem.term,
                    }
                  })
                }
              )
            )
            return {
              coverageCode: subRider.riderName.value,
              sumAssured: Number(subRider.sumAssured),
              policyPeriod: Number(subRider.policyPeriod),
              healthcareBenefitDetailList: healthcareBenefitDetailArray
            }
          }),
          duplicatePhones:
            !!newItem.newLAInfo && !!newItem.newLAInfo?.dupPhone
              ? newItem.newLAInfo?.dupPhone.map((p) => ({
                clientName: p.clientName ?? '',
                clientID: p.clientId ?? '',
                relationshipType: p.relationship?.value ?? ''
              }))
              : [],
          duplicateEmails:
            !!newItem.newLAInfo && !!newItem.newLAInfo?.dupEmail
              ? newItem.newLAInfo?.dupEmail.map((e) => ({
                clientName: e.clientName ?? '',
                clientID: e.clientId ?? '',
                relationshipType: e.relationship?.value ?? ''
              }))
              : [],
          addressDetails: {
            ADDRESS: {
              line1: newItem?.newLAInfo?.street ?? '',
              city: newItem.newLAInfo?.city?.label ?? '',
              district: newItem.newLAInfo?.district?.label ?? '',
              subDistrict: newItem.newLAInfo?.ward?.label ?? '',
              countryCode: newItem.newLAInfo?.country?.value ?? '',
              location: locationCode
            },
            FOREIGN_ADDRESS: {
              line1: newItem.newLAInfo?.foreignAddress ?? '',
              countryCode: newItem.newLAInfo?.countryOfForeignAddress?.value ?? ''
            }
          },
          attributesExt: {
            NATIONALITY_2: newItem.newLAInfo?.nationality2?.value ?? '',
            nationality2Name: newItem.newLAInfo?.nationality2?.label ?? '',
            countryName: newItem.newLAInfo?.country?.label ?? '',
            districtName: newItem.newLAInfo?.district?.label ?? '',
            wardName: newItem.newLAInfo?.ward?.label ?? '',
            cityCode: newItem.newLAInfo?.city?.value ?? '',
            districtCode: newItem.newLAInfo?.district?.value ?? '',
            subDistrictCode: newItem.newLAInfo?.ward?.value ?? ''
          }
        }
        return {
          lifeAssured: newLifeAssured
        }
      })
    const submitedData: RiderAlterationData.SubmissionData = {
      isRiderAlteration: riderForm.isRiderAlteration,
      isAddLA: riderForm.isAddRider,
      requiredPayInAmount: requiredPayInAmount,
      lifeAssuredList: lifeAssuredList,
      lifeAssuredAdditions: lifeAssuredAdditions,
      isCheckedBenefitsRegistrationBlock: riderForm.isCheckedBenefitsRegistrationBlock,
    }
    // console.log('submitedData:', JSON.stringify(submitedData))
    return submitedData
  }

  const getUploadedFilesInfo = (riderForm: RiderAlterationFormData.RiderAlteration) => {
    let uploadedFileList: UploadedFilesInfo[] = []
    let identifyDocuments: FileUploadData[] = []
    riderForm.newRiderLAList.map((newLA) => {
      identifyDocuments =
        newLA.isNewLA && !!newLA.newLAInfo
          ? [...identifyDocuments, ...newLA.newLAInfo?.identifyDocument]
          : identifyDocuments
    })
    if (identifyDocuments.length > 0) {
      uploadedFileList.push({
        uploadFiles: identifyDocuments,
        transactionType: TransactionType.RIDER_ALTERATION,
        docTypeCode: 'DPS10',
        category: TaskType.PolicyService,
        policyNumber: policyNum ?? '',
        officeCode: officeCode ?? ''
      })
    }
    //health declaration
    uploadedFileList.push({
      uploadFiles: riderForm.healthDocuments,
      transactionType: TransactionType.RIDER_ALTERATION,
      docTypeCode: 'DPS09',
      category: TaskType.PolicyService,
      policyNumber: policyNum ?? '',
      officeCode: officeCode ?? ''
    })
    return uploadedFileList
  }

  const validateNextStepForPolicyBenefitRegistration = () => {
    let isValid = true
    const formData = riderAlterationForm.watch()
    if (formData.isCheckedBenefitsRegistrationBlock && !formData.newRiderLAList.some((item) => item.isCheckedBenefitsRegistration)) {
      showToast(t('message:MS020132'), 'error')
      isValid = false
    } else {
      isValid = true
    }
    return isValid
  }

  props.initSubmission({
    validate: async (isContinue) => {
      const isValidForm = await riderAlterationForm.trigger()
      if (isValidForm && validateNextStepForPolicyBenefitRegistration()) {
        const riderForm = riderAlterationForm.getValues()
        return {
          url: (policyNumber) => `wf-api/policy/${policyNumber}/rider-alteration`,
          body: getRiderSubmissionData(riderForm),
          transactionName: RequestAuthenticateData.TransactionLabelShort(TransactionType.RIDER_ALTERATION),
          collerationId: policyNum,
          transaction: TransactionType.RIDER_ALTERATION,
          uploadedFilesInfo: getUploadedFilesInfo(riderForm)
        }
      } else {
        return false
      }
    },
    clear: () => {
      riderAlterationForm.reset({
        LARiderAlterationList: [],
        newRiderLAList: [],
        healthDocuments: [],
        isAddRider: false,
        isRiderAlteration: false,
        requiredPayinAmount: '',
        totalPremium: 0
      })
      initData(riderDetail as CancelRider.DetailCancelRiderInfo, waiverProductList, classList, riskTypeList)
    }
  })

  return (
    <View style={riderStyles.container}>
      <Title title={t('requestInfo:RequestDetail')} wrapperStyle={riderStyles.titleText}></Title>
      <Controller
        control={riderAlterationForm.control}
        name={'isRiderAlteration'}
        render={({ field: { value, onChange, onBlur } }) => (
          <Checkbox
            title={t('RiderAlteration:RiderAlteration')}
            onChange={(checked) => {
              onChange(checked)
              // changeEventForLA(checked, index, fieldItem)
            }}
            onBlur={onBlur}
            value={value}
            disabled={props.isConfirmed}
            checkBoxStyle={riderStyles.tableCheckBox}
          />
        )}
      />
      {riderAlterationForm.watch('isRiderAlteration') && (
        <SectionContent sectionStyles={{ backgroundColor: '#fff' }}>
          <LifeAssuredTable
            riderAlterationForm={riderAlterationForm}
            LAFieldList={LAFieldList}
            isConfirmed={props.isConfirmed}
          ></LifeAssuredTable>
        </SectionContent>
      )}
      <View style={riderStyles.secondLine}>
        <Controller
          control={riderAlterationForm.control}
          name={'isAddRider'}
          render={({ field: { value, onChange, onBlur } }) => (
            <Checkbox
              title={t('RiderAlteration:AddRider')}
              onChange={(checked) => {
                onChange(checked)
                // changeEventForLA(checked, index, fieldItem)
              }}
              onBlur={onBlur}
              value={value}
              disabled={props.isConfirmed}
              checkBoxStyle={riderStyles.tableCheckBox}
            />
          )}
        />
      </View>
      {riderAlterationForm.watch('isAddRider') && (
        <SectionContent sectionStyles={{ backgroundColor: '#fff' }}>
          <AlterRiderTable
            // newRiderList={newRiderList}
            riderAlterationForm={riderAlterationForm}
            NewRiderLAList={NewRiderLAList}
            disabled={props.isConfirmed}
            addNewRider={addNewRiderForExistedLA}
            removeRider={removeRiderForExistedLA}
            removeNewLA={removeNewLA}
            viewLADetail={viewLADetail}
            onChangeRider={onChangeNewRider}
            onEditRiderEvent={onEditRiderEvent}
          ></AlterRiderTable>
          {NewRiderLAList.fields.length < 4 && !props.isConfirmed && (
            <View style={riderStyles.btnNewLA}>
              <TouchableOpacity onPress={() => openInsertLAModal(false)}>
                <View style={riderStyles.btnAdd}>
                  <Text style={riderStyles.btn_text}>{t('RiderAlteration:AddNewLA')}</Text>
                </View>
              </TouchableOpacity>
            </View>
          )}
        </SectionContent>
      )}
      {riderAlterationForm.watch('isShowBenefitsRegistrationBlock') && (
        <View style={riderStyles.secondLine}>
          <Controller
            control={riderAlterationForm.control}
            name={'isCheckedBenefitsRegistrationBlock'}
            render={({ field: { value, onChange, onBlur } }) => (
              <Checkbox
                title={t('RiderAlteration:PolicyBenefitsRegistration')}
                onChange={(checked) => {
                  onChange(checked)
                }}
                onBlur={onBlur}
                value={value}
                disabled={props.isConfirmed}
                checkBoxStyle={riderStyles.tableCheckBox}
              />
            )}
          />

        </View>
      )}
      {riderAlterationForm.watch('isCheckedBenefitsRegistrationBlock') && (
        <SectionContent sectionStyles={{}}>
          <PolicyBenefitRegistrationBlock
            isConfirmed={props.isConfirmed}
            riderAlterationForm={riderAlterationForm}
            NewRiderLAList={NewRiderLAList}
            riderNameList={riderDetail?.riderNameList || []}
            setIsDeletedNewLAForBenefitsRegistration={setIsDeletedNewLAForBenefitsRegistration}
            onCheckBenefitsRegistrationEvent={onCheckBenefitsRegistrationEvent}
            onViewLADetailEvent={viewLADetail}
          />
          {NewRiderLAList.fields && !props.isConfirmed && !NewRiderLAList.fields.some((item) => item.isNewLAForBenefitsRegistration) && (
            <View style={riderStyles.btnNewLA}>
              <TouchableOpacity onPress={() => openInsertLAModal(true)}>
                <View style={riderStyles.btnAdd}>
                  <Text style={riderStyles.btn_text}>{t('RiderAlteration:AddNewLA')}</Text>
                </View>
              </TouchableOpacity>
            </View>
          )}
        </SectionContent>
      )}

      <Title wrapperStyle={riderStyles.secondLine} title={t('submission:StatementOfInsurability')}></Title>
      <View style={{ flex: 1 }}>
        <Text style={riderStyles.field_title}>
          {t('submission:HealthNote')}
          <Link href={`${assets.UpdatedRedatingHealthyTemplate}`} target="_parent" download>
            <Text style={riderStyles.underlineLink}>{t('submission:Here')}</Text>
          </Link>
        </Text>
        <Text style={riderStyles.field_title}>
          {t('submission:HealthDeclaration')} <Text style={riderStyles.redLine}> *</Text>
        </Text>
        <Controller
          control={riderAlterationForm.control}
          name={'healthDocuments'}
          rules={{
            required: {
              value: true,
              message: t('message:MS050232')
            }
          }}
          render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
            <>
              <ImgUploadMutiple
                timeFormat={'DD/MM/YYYY HH:mm'}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={props.isConfirmed}
              />
              {error?.message && <Error message={value && value.length > 0 ? '' : error.message} />}
            </>
          )}
        />
      </View>
      <Title wrapperStyle={riderStyles.secondLine} title={t('submission:TEMPORARYPAYININFO')}></Title>
      <SectionRow>
        <SectionCol>
          <Controller
            control={riderAlterationForm.control}
            name={'requiredPayinAmount'}
            render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
              <Input
                title={t('submission:RequirePayInAmount')}
                // required={true}
                inputType={'money'}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={props.isConfirmed}
                errorMessage={!!value ? error?.message : ''}
              />
            )}
          />
        </SectionCol>
      </SectionRow>
      {openInsertedNewLAPopUp()}
      <RiderDeleteModal
        visible={isDeletedNewLAForBenefitsRegistration.status}
        onPressClose={() => setIsDeletedNewLAForBenefitsRegistration((val) => ({ index: val.index, status: false }))}
        onPressSubmit={() => {
          !!removeNewLA && removeNewLA(isDeletedNewLAForBenefitsRegistration.index)
          setIsDeletedNewLAForBenefitsRegistration((val) => ({ index: val.index, status: false }))
        }}
      />
      <HealthcareDetailPanelModal
        isOpen={isOpenedHealthcareDetail}
        title={t('HealthcareDetailPopup:HealthcareDetailPanel')}
        riderAlterationForm={riderAlterationForm}
        riderLAIndex={riderLAIndex}
        riderSubIndex={riderSubindex}
        onClose={() => setIsOpenedHealthcareDetail(false)}
        onConfirm={() => setIsOpenedHealthcareDetail(false)}
        riderAlterationDetailData={riderDetail}
        healthcareBenefitMasterData={healthcareMasterDataList}
        isDisabled={props.isConfirmed}
        previousHealthcareBenefitList={previousHealthcareBenefitList}
      />
    </View>
  )
}

const riderStyles = StyleSheet.create({
  container: {
    marginBottom: 40,
    flex: 1
  },
  titleText: {
    marginTop: 30
  },
  currencyContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingRight: 20
  },
  currentText: {
    fontStyle: 'italic'
  },
  tableHeaderText: {
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 13,
    color: '#70777E'
  },
  tableCheckBox: {
    padding: 0,
    marginTop: 0,
    paddingLeft: 10
  },
  btnContent: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  btnNewLA: {
    marginTop: 15,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  btnAdd: {
    minHeight: 40,
    width: '100%',
    borderRadius: 100,
    paddingHorizontal: 25,
    paddingVertical: 10,
    borderColor: '#ED1B2E',
    borderWidth: 1
    // backgroundColor: '#ED1B2E'
  },
  btn_text: {
    fontSize: 15,
    lineHeight: 20,
    color: '#ED1B2E',
    fontWeight: 'bold'
  },
  secondBtn: {
    marginLeft: 27
  },
  underlineLink: {
    textDecorationLine: 'underline'
  },
  field_title: {
    color: '#70777E',
    fontSize: 15,
    fontWeight: 'bold',
    lineHeight: 20,
    marginBottom: 8
  },
  panelContent: {
    backgroundColor: '#fff',
    // marginTop: 20,
    borderWidth: 0,
    borderColor: '#fff'
  },
  secondLine: {
    marginTop: 20
  },
  redLine: {
    color: '#ed1b2c',
    fontSize: 15,
    fontWeight: 'bold'
  }
})
